import "./App.css";
import { useContext, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes, useLocation, Link } from "react-router-dom";
import Header from "./layout/Header";
import "leaflet/dist/leaflet.css";
import "./styles/modal.css";
import "./styles/fullScreenLoader.css";
import "./styles/responsive.css";
import "./styles/keyframes.css";
import "./styles/payment.css";
import StoreSectionPage from "./pages/StoreSectionPage";
import StoreMapPage from "./pages/StoreMapPage";
import CityModal from "./components/CityModal";
import FullScreenLoader from "./global/FullScreenLoader";
import { StoreContext } from "./context/StoreContext";
import DeleteAccount from "./pages/DeleteAccount";
import UnAuthorised from "./pages/UnAuthorised";
import PaymentSuccess from "./payment-gateway/PaymentSuccess";
import PaymentFailed from "./payment-gateway/PaymentFailed";
import PaymentCancel from "./payment-gateway/PaymentCancel";
import UrlPayment from "./payment-gateway/UrlPayment";
import PaymentAlreadyDone from "./payment-gateway/PaymentAlreadyDone";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ScrollToTop from "./components/ScrollToTop";
import TermsAndConditions from "./pages/TermsAndConditions";
import CancellationAndRefund from "./pages/CancellationAndRefund";
import ShippingPolicy from "./pages/ShippingPolicy";

function App() {
  const { currentLocLoader, getIPLocation, showModal, setShowModal } =
    useContext(StoreContext);
  const location = useLocation();

  const isUrlPayment = location.pathname.startsWith("/urlPayment");
  const hideLayoutRoutes = [
    "/payment-paid",
    "/payment-success",
    "/payment-failed",
    "/payment-cancel",
  ];

  const shouldHideLayout =
    hideLayoutRoutes.includes(location.pathname) || isUrlPayment;

  const lat = parseFloat(localStorage.getItem("selectedCityLat"));

  useEffect(() => {
    const hasModalBeenShown = localStorage.getItem("modalShown");
    const cityAvailable = localStorage.getItem("selectedCity");
    if (!lat) {
      getIPLocation();
    }

    if (!hasModalBeenShown && !cityAvailable) {
      setShowModal(true);
    }
  }, []);

  return (
    <div className="App global-app-wrapper">
      <ScrollToTop />
      <FullScreenLoader isLoading={currentLocLoader} />
      {!shouldHideLayout && (
        <CityModal showModal={showModal} setShowModal={setShowModal} />
      )}
      {!shouldHideLayout && <Header setShowModal={setShowModal} />}

      <Routes>
        <Route
          path="/"
          element={
            <>
              <StoreMapPage />
              <StoreSectionPage />
            </>
          }
        />

        <Route path="/deleteUser" element={<DeleteAccount />} />

        <Route path="/unauthorisedUser" element={<UnAuthorised />} />

        <Route
          path="/urlPayment/transactionNo/:transactionNo"
          element={<UrlPayment />}
        />
        <Route path="/payment-paid" element={<PaymentAlreadyDone />} />
        <Route path="/payment-success" element={<PaymentSuccess />} />
        <Route path="/payment-failed" element={<PaymentFailed />} />
        <Route path="/payment-cancel" element={<PaymentCancel />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-conditions" element={<TermsAndConditions />} />
        <Route path="/shipping-policy" element={<ShippingPolicy />} />
        <Route
          path="/cancellation-refund"
          element={<CancellationAndRefund />}
        />
      </Routes>

      {!shouldHideLayout && (
        <div className="footer-section">
          &copy; 2025 Ezybuy.shop All rights reserved.
          <span className="footer-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-conditions">Terms & Conditions</Link>
            <Link to="/cancellation-refund">Cancellation & Refund</Link>
            <Link to="/shipping-policy">Shipping Policy</Link>
          </span>
        </div>
      )}
    </div>
  );
}

export default App;
